module.exports = __webpack_public_path__ + "img/logo_white.5b89d580.svg";